<template>
    <div class="container">
        <div class="get-result">
            <span class="section-title">Danke, dass sie sich die Zeit genommen haben</span>

            <h1 class="headline-md">Bitte hinterlassen Sie uns Ihre E-Mail-Adresse und und wir werden Sie über die Ergebnisse informieren.</h1>

            <form id="quiz-form" role="form" method="POST" action="#" @submit.prevent="submit" novalidate>
                <form-input-type-email
                    name="email"
                    label="E-Mail-Adresse"
                    :errors="errors.email"
                    full-border
                    required
                ></form-input-type-email>

                <form-input-type-checkbox
                    name="agreements"
                    label='Durch Eingabe Ihres Namens und Ihrer E-Mail-Adresse erklären Sie sich mit den Bestimmungen zum <a href="/datenschutzerklarung" target="_blank">Datenschutz</a> einverstanden.'
                    :errors="errors.agreements"
                    required
                ></form-input-type-checkbox>

                <v-button label="Testergebnis anfordern" type="submit" full-width></v-button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            totalScore: {
                type: Number,
                required: true
            },
            answers: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                errors: {}
            }
        },
        created() {
            window.scrollTo(0, 0)
        },

        methods: {
            submit() {
                let formData = {}

                // serialize form data
                $('#quiz-form')
                    .serializeArray()
                    .forEach(({ name, value }) => {
                        formData[name] = value
                    })

                formData['score'] = this.totalScore
                formData['answers'] = JSON.stringify(this.answers)

                axios
                    .post('api/patient-quiz-form', formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        window.location.replace('result-page?score=' + this.totalScore)
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
        }
    }
</script>
